var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"action-icons-bar",style:({
      'background-color': _vm.getWebchat().campaign.color,
    }),attrs:{"height":"67px"}},[_c('v-toolbar-title',[(_vm.getWebchat().isLowRes)?_c('v-btn',{staticClass:"left-arrow-back",attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.minimizeWindow.apply(null, arguments)}}},[_c('v-icon',{staticStyle:{"margin-top":"12px"},style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          }),attrs:{"x-large":""}},[_vm._v("mdi-chevron-left")])],1):_vm._e(),(
          _vm.getWebchat().campaign.show_agent &&
          !_vm.getWebchat().interaction.transfering
        )?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          'background-image':
            'url(' +
            _vm.getWebchat().menu.menu_img +
            '?' +
            new Date().getTime() +
            ')',
        })}):(
          !_vm.getWebchat().campaign.show_agent &&
          !_vm.getWebchat().interaction.transfering &&
          _vm.getWebchat().campaign.logo
        )?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          'background-image': 'url(' + _vm.getWebchat().campaign.logoName + ')',
        })}):(!_vm.getWebchat().interaction.transfering)?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({ 'background-image': 'url(' + _vm.avatar + ')' })}):(_vm.getWebchat().interaction.transfering)?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        }},[_c('v-icon',{staticClass:"spinIcon",staticStyle:{"font-size":"50px !important"},style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          })},[_vm._v(" mdi-autorenew ")])],1):_vm._e(),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [(_vm.getWebchat().campaign.show_agent &&
            !_vm.getWebchat().interaction.transfering
            )?_c('span',_vm._g({staticClass:"agent-name",class:{
            isLowRes: _vm.getWebchat().isLowRes,
          },style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          })},on),[_vm._v(_vm._s(_vm.getWebchat().interaction.agent)+" ")]):(!_vm.getWebchat().campaign.show_agent &&
            !_vm.getWebchat().interaction.transfering
            )?_c('span',_vm._g({staticClass:"agent-name",class:{
            isLowRes: _vm.getWebchat().isLowRes,
          },style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          })},on),[_vm._v("CHAT ")]):(_vm.getWebchat().interaction.transfering)?_c('span',_vm._g({staticClass:"agent-name",class:{
            isLowRes: _vm.getWebchat().isLowRes,
          },style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          })},on),[_vm._v(_vm._s(_vm.$t("transfering"))+" ")]):_vm._e(),(!_vm.getWebchat().interaction.transfering)?_c('p',_vm._g({staticClass:"response-time",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          color: _vm.invertColor(_vm.getWebchat().campaign.color),
        })},on),[_vm._v(" "+_vm._s(_vm.$t("available"))+" ")]):_vm._e()]}}])},[(_vm.getWebchat().campaign.show_agent &&
            !_vm.getWebchat().interaction.transfering
            )?_c('span',[_vm._v(" "+_vm._s(_vm.getWebchat().interaction.agent))]):(!_vm.getWebchat().campaign.show_agent &&
            !_vm.getWebchat().interaction.transfering
            )?_c('span',[_vm._v("CHAT")]):(_vm.getWebchat().interaction.transfering)?_c('span',[_vm._v(_vm._s(_vm.$t("transfering")))]):_vm._e()])],1),_c('v-spacer'),(!_vm.getWebchat().isLowRes)?_c('v-toolbar-items',_vm._l((_vm.buttons.filter(function (b) { return b.show(); })),function(button,index){return _c('v-tooltip',{key:index,attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","id":button.id,"disabled":button.disabled()},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return button.action.apply(null, arguments)}}},on),[_c('v-icon',{style:({
                color: _vm.invertColor(_vm.getWebchat().campaign.color),
              })},[_vm._v(" mdi-"+_vm._s(button.icon)+" ")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t(button.text)))])])}),1):_c('v-toolbar-items',[_c('v-menu',{attrs:{"z-index":"1000000"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
              var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"dark":"","icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}])},[_c('v-list',_vm._l((_vm.buttons.filter(function (b) { return b.show(); })),function(button,index){return _c('v-list-item',{key:index,attrs:{"id":button.id,"disabled":button.disabled()},on:{"click":button.action}},[_c('v-list-item-icon',{staticClass:"mr-3"},[_c('v-icon',[_vm._v("mdi-"+_vm._s(button.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(button.text)))])],1)],1)}),1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }